/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

export function filename(path) {
  let parts = path.split("/");
  return parts[parts.length - 1];
}

export function extension(filename) {
  if (!filename) return null;
  if (filename.indexOf("blob:") === 0) return "blob";
  let parts = filename.split(".");
  if (parts.length === 0) return null;
  return parts[parts.length - 1];
}
